export default __webpack_public_path__ + "static/media/economic1.45e1751e.jpg";